import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/apiService';

const BASE_URL = 'https://admin.defconinnovations.com/advocateapi';

export const useCases = () => {
  const queryClient = useQueryClient();

  const useGetCases = () =>
    useQuery({
      queryKey: ['cases'],
      queryFn: () => apiService.get(BASE_URL, '/cases/'),
    });

  const useAddCase = () =>
    useMutation({
      mutationFn: data => apiService.post(BASE_URL, '/cases/', data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['cases'] });
      },
    });

  const useUpdateCase = () =>
    useMutation({
      mutationFn: ({ id, data }) =>
        apiService.patch(BASE_URL, `/cases/${id}/`, data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['cases'] });
      },
    });

  const useDeleteCase = () =>
    useMutation({
      mutationFn: id =>
        apiService.patch(BASE_URL, `/cases/${id}/`, { is_archive: true }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['cases'] });
      },
    });

  return {
    useGetCases,
    useAddCase,
    useUpdateCase,
    useDeleteCase,
  };
};
